// extracted by mini-css-extract-plugin
module.exports = {"queue-controls":"queue_queue-controls__27WEl","header-row":"queue_header-row__1Stwa","heading-container":"queue_heading-container__2-NUl"};